<template>
  <div class="col-sm-12">
    <div
      class="data-list-item add"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="calendar-check"
          class="card-body-icon"
        />
      </div>
    </div>

      <div class="col-12 nopads my-2 list-container">
          <Transition name="fade">
              <div v-if="results.length > 0" class="col-sm-12 list-content result-table">
                  <vue3-datatable
                      ref="resultTable"
                      :rows="results"
                      :columns="fields"
                      :pagination="false"
                      :sticky-header="true"
                      height="100%"
                      :sortable="true"
                      skin="bh-table-compact"
                      row-class="routa-table-row"
                      cell-class="routa-table-cell"
                      @row-click="emitEdit"
                  />
              </div>
          </Transition>
      </div>
  </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'ContractCollectionList',
    components: {Vue3Datatable},
    data() {
       return {
           fields: [
               {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
               {field: 'name', title: this.$t('companies.name'), sort: true, headerClass: 'routa-table-header'}
           ]
       }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
